import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import { AuthContextProvider } from './contexts/auth-context'
import { ThemeProvider } from './contexts/theme-context'
import { Toaster } from './components/ui/sonner'
import { AppErrorBoundary } from './components/shared/error-boundary'
import { AppRoutes } from './routes/app-routes'
import './styles/styles.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppErrorBoundary>
      <BrowserRouter>
        <ThemeProvider>
          <AuthContextProvider>
            <AppRoutes />
          </AuthContextProvider>
          <Toaster />
        </ThemeProvider>
      </BrowserRouter>
    </AppErrorBoundary>
  </StrictMode>,
)
